// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import LegacyLink from '../../Common/LegacyLink';
import Zendesk from '../../Common/ZendeskLink';

type Props = {
  secondaryClass: string,
  isAdmin: boolean,
  user: ?any,
  isStatic: boolean,
  hideFindParking: boolean,
  secondaryVisible: boolean,
  toggleSecondary: () => void
};

const SecondaryNav = ({
  secondaryClass,
  isAdmin,
  user,
  isStatic,
  hideFindParking,
  toggleSecondary,
  secondaryVisible
}: Props) => {
  const isSpaceOwner = user?.isSpaceOwner;
  const hasSeasonTickets = user?.hasSeasonTicket;

  const onClick = (e, isLegacy) => {
    if (isLegacy) {
      return;
    }

    if (secondaryVisible) {
      toggleSecondary(e);
    }
  };

  return (
    <ul className={`${secondaryClass} c-header__menu--secondary`}>
      {isAdmin && [
        <li onClick={e => onClick(e, true)} key="su">
          <LegacyLink to="admin/su/">SU</LegacyLink>
        </li>,
        <li onClick={e => onClick(e, true)} key="admin">
          <LegacyLink to="admin/">Admin</LegacyLink>
        </li>
      ]}

      {!hideFindParking && (
        <li onClick={onClick} className="desktop-hidden">
          <Link onClick={onClick} to="/">
            Find parking
          </Link>
        </li>
      )}

      {!user && (
        <li onClick={e => onClick(e, true)} className="desktop-hidden">
          <LegacyLink to="about">About</LegacyLink>
        </li>
      )}

      {user && (
        <>
          <li onClick={onClick} key="bookings-made">
            <Link to="/dashboard/bookings/made">Bookings made</Link>
          </li>

          {isSpaceOwner && (
            <li onClick={e => onClick(e, true)} key="bookings-received">
              <LegacyLink to="dashboard/bookings/received">
                Bookings received
              </LegacyLink>
            </li>
          )}

          {hasSeasonTickets && (
            <li onClick={e => onClick(e, true)} key="season-tickets">
              <LegacyLink to="dashboard/season-tickets">
                Tickets & permits
              </LegacyLink>
            </li>
          )}

          <li onClick={e => onClick(e, true)} key="messages">
            <LegacyLink to="dashboard/messaging/">
              Messages
              {user.unreadMessages > 0 && <div>{user.unreadMessages}</div>}
            </LegacyLink>
          </li>

          {isSpaceOwner && (
            <li onClick={onClick}>
              <Link to="/dashboard/parking-spaces">Manage my spaces</Link>
            </li>
          )}

          <li onClick={e => onClick(e, true)}>
            <LegacyLink to="dashboard/billing/">
              Billing & withdrawals
            </LegacyLink>
          </li>

          <li onClick={onClick}>
            <Link to="/dashboard/profile/">My profile</Link>
          </li>
        </>
      )}

      {!isSpaceOwner && (
        <li
          onClick={e => onClick(e, true)}
          key="rentoutdriveway"
          className="desktop-hidden"
        >
          <LegacyLink to="about/rent-your-space/">
            Rent out your driveway
          </LegacyLink>
        </li>
      )}

      <li onClick={onClick} key="downloadapp" className="desktop-hidden">
        <a href="https://justpark.onelink.me/3963458492?c=website-homepage&af_dp=justpark://download-app">
          Download our app
        </a>
      </li>

      {user && (
        <li onClick={onClick}>
          <Link to="/refer-a-friend">Get free parking</Link>
        </li>
      )}

      <li onClick={onClick} key="help" className="desktop-hidden">
        <Zendesk isStatic={isStatic}>Help</Zendesk>
      </li>

      {user && (
        <li onClick={onClick} key="logout">
          <Link to="/auth/logout">Log out</Link>
        </li>
      )}

      {!user && (
        <li onClick={onClick} className="desktop-hidden">
          <Link to="/auth/login">Sign up / login</Link>
        </li>
      )}
    </ul>
  );
};

export default SecondaryNav;
